import {
  Box, Button, Card,
  CardContent, Chip, Container,
  Grid, Typography
} from "@mui/material";
import { useEffect, useState } from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { getConfigs } from "../../../configs";
import OrganizationSelector from "../../common/appHeader/OrganizationSelector";
import GitlabIntegrationForm from "../integrations/AddIntegrations/GitlabIntegrationForm";
import Webhook from "../integrations/AddIntegrations/Webhook";
import Members from "../members/members";
import Metrics from "../metrics/metrics";
import MultipleJiraIntegrationForm from "../integrations/AddIntegrations/MultipleJiraIntegrationForm";
import { IUserStoreState, useUserStore } from "../../../store/userState";
import { useFeatureState } from "../../../store/featureState";
import { FEATURES, ROUTES } from "../../../constants";
import GithubIntegrationForm from "../integrations/AddIntegrations/GithubIntegrationForm";
import GitHubIcon from '@mui/icons-material/GitHub';
import { axiosInstance } from "../../../services/axios";

const OrganizationSettings: React.FC<RouteComponentProps> = ({ history }) => {
  const [jiraStatus, setJiraStatus] = useState(false);
  const [gitlabStatus, setGitlabStatus] = useState(false);
  const [githubStatus, setGithubStatus] = useState(false);
  const [githubAppUrl, setGithubAppUrl] = useState<string>("");
  const { currentUser } = useUserStore((state) => state) as IUserStoreState;
  const { features } = useFeatureState(state => state)

  useEffect(() => {
    fetchGithubIntegration()
  }, [])

  const fetchGithubIntegration = async () => {
      try {
        let response = await axiosInstance.get('/cloudintegration')
        setGithubStatus(response?.data?.github?.isActive)
        setGithubAppUrl(response?.data?.github?.appUrl)
        
      } catch (error) {
  
      }
  
  }

  return (
    <>
      <Box
        sx={{
          backgroundColor: "background.default",
          display: "flex",
          flexDirection: "column",
          minHeight: '100%',
        }}
      >
        <Container maxWidth="xl" sx={{ px: 3, pt: 2, pb: 0 }}>
          <Card sx={{ border: "none", boxShadow: "none" }}>
            <CardContent
              sx={{
                display: "flex",
                flexDirection: "column",
                p: 3,
              }}
            >
              <Box
                sx={{
                  flexGrow: 1,
                }}
              >
                <Grid sx={{ textAlign: "left" }} container>
                  <Grid md={3}>
                    <div>
                      <Typography color="textPrimary" gutterBottom variant="h5">
                        Current Organization
                      </Typography>
                    </div>
                  </Grid>

                  <Grid md={9} spacing={3}>
                    <Card sx={{ border: "none", boxShadow: "none" }}>
                      <CardContent
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          p: 3,
                        }}
                      >
                        <Box
                          sx={{
                            flexGrow: 1,
                          }}
                        >
                          <OrganizationSelector />
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                </Grid>
              </Box>
            </CardContent>
          </Card>
          <Metrics />

          <Card sx={{ border: "none", boxShadow: "none" }}>
            <CardContent
              sx={{
                display: "flex",
                flexDirection: "column",
                p: 3,
              }}
            >
              <Box
                sx={{
                  flexGrow: 1,
                }}
              >
                <Grid sx={{ textAlign: "left" }} container>
                  <Grid md={3}>
                    <div>
                      <Typography color="textPrimary" gutterBottom variant="h5">
                        Members
                      </Typography>
                    </div>
                  </Grid>

                  <Grid md={9} spacing={3}>
                    <Card sx={{ border: "none", boxShadow: "none" }}>
                      <CardContent
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          p: 3,
                        }}
                      >
                        <Box
                          sx={{
                            flexGrow: 1,
                          }}
                        >
                          <Members />
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                </Grid>
              </Box>
            </CardContent>
          </Card>
          <Card sx={{ border: 'none', boxShadow: 'none' }}>
            <CardContent
              sx={{
                display: 'flex',
                flexDirection: 'column',
                p: 3
              }}
            >
              <Box
                sx={{
                  flexGrow: 1,
                }}
              >

                <Grid sx={{ textAlign: "left" }} container>
                  {currentUser.role === 'owner' &&
                    <>
                      <Grid
                        md={3}
                      >

                        <div>
                          <Typography
                            color="textPrimary"
                            gutterBottom
                            variant="h5"
                          >
                            Jira
                          </Typography>
                        </div>


                      </Grid>


                      <Grid md={9} spacing={3}>
                        <Box sx={{ border: 'none', boxShadow: 'none', display: 'flex',
                              flexDirection: 'column',
                              px:3, }}>
                          

                            <Box
                              sx={{
                                flexGrow: 1,
                              }}
                            >
                              <MultipleJiraIntegrationForm setJiraStatus={setJiraStatus} />
                            </Box>
                         
                        </Box>
                      </Grid>

                      {features.includes(FEATURES.GITLAB_INTEGRATION) && (
                        <>
                      <Grid
                        md={3}
                        sx={{mt:4}}
                      >

                        <Box sx={{display: 'flex', alignItems: 'center'}}>
                          <Typography
                            color="textPrimary"
                            gutterBottom
                            variant="h5"
                          >
                            Gitlab 
                          </Typography>
                          <Typography variant="body1" gutterBottom sx={{ml:1,  fontWeight: '600'}} color={gitlabStatus ? "secondary" : "error"} >&bull; {gitlabStatus ? " Active" : " Inactive"}</Typography>
                        </Box>


                      </Grid>
                        <Grid md={9} spacing={3} sx={{mt:4}}>
                          <Box sx={{ border: 'none', boxShadow: 'none', display: 'flex',
                                flexDirection: 'column',
                                px: 3 }}>
                            

                              <Box
                                sx={{
                                  flexGrow: 1,
                                }}
                              >
                                <GitlabIntegrationForm setGitlabStatus={setGitlabStatus} />

                              </Box>
                            
                          </Box>
                        </Grid></>)}
                      {features.includes(FEATURES.GITLAB_INTEGRATION) && (
                        <>
                          <Grid
                            md={3}
                            sx={{ mt:4 }}
                          >

                            <Box sx={{display: 'flex', alignItems: 'center'}}>
                              <Typography
                                color="textPrimary"
                                gutterBottom
                                variant="h5"
                              >
                                Github
                              </Typography>
                              <Typography variant="body1" gutterBottom sx={{ml:1,  fontWeight: '600'}} color={githubStatus ? "secondary" : "error"} >&bull; {githubStatus ? " Active" : " Inactive"}</Typography>
                            </Box>


                          </Grid>
                          <Grid md={9} spacing={3} sx={{ mt:4, px:3 }}>
                            <Card elevation={5} >
                            <CardContent >
                              <Button size='medium' variant='contained' onClick={() => window.open(githubAppUrl)}>
                                <GitHubIcon sx={{ mr: 1 }} /> Connect to Github
                              </Button>

                              <Button
                                color="primary"
                                size="medium"
                                variant="outlined"

                                onClick={() => window.open(`${ROUTES.CLOUD_CONFIGURATION}?type=github`, "_self")}
                                sx={{ ml: 2 }}
                              >
                                Configure
                              </Button>
                            </CardContent>
                            </Card>
                          </Grid>
                        </>)
                      }
                    </>
                  }
                </Grid>
              </Box>
            </CardContent>
          </Card>

          {getConfigs().experimentalFeatures && (
            <Card sx={{ border: 'none', boxShadow: 'none', mt: 3 }}>
              <CardContent
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  p: 3
                }}
              >
                <Box
                  sx={{
                    flexGrow: 1,
                  }}
                >
                  <Grid sx={{ textAlign: "left" }} container>
                    <Grid
                      md={3}
                    >

                      <div>
                        <Typography
                          color="textPrimary"
                          gutterBottom
                          variant="h5"
                        >
                          Webhook
                        </Typography>
                      </div>


                    </Grid>

                    <Grid md={9} spacing={3}>
                      <Card sx={{ border: 'none', boxShadow: 'none' }}>
                        <CardContent
                          sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            p: 3
                          }}
                        >

                          <Box
                            sx={{
                              flexGrow: 1,
                            }}
                          >
                            <Webhook />
                          </Box>
                        </CardContent>
                      </Card>
                    </Grid>
                  </Grid>
                </Box>
              </CardContent>
            </Card>
          )}

        </Container>
      </Box>
    </>
  );
};

export default withRouter(OrganizationSettings);